export default "__VITE_ASSET__66ba62b1__"